import { u as Z } from "./index.esm-G8KyR0tM.js";
var ae = {}, ie = {};
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.errorMessages = s.ErrorType = void 0;
  var e;
  (function(t) {
    t.MalformedUnicode = "MALFORMED_UNICODE", t.MalformedHexadecimal = "MALFORMED_HEXADECIMAL", t.CodePointLimit = "CODE_POINT_LIMIT", t.OctalDeprecation = "OCTAL_DEPRECATION", t.EndOfString = "END_OF_STRING";
  })(e = s.ErrorType || (s.ErrorType = {})), s.errorMessages = /* @__PURE__ */ new Map([
    [e.MalformedUnicode, "malformed Unicode character escape sequence"],
    [
      e.MalformedHexadecimal,
      "malformed hexadecimal character escape sequence"
    ],
    [
      e.CodePointLimit,
      "Unicode codepoint must not be greater than 0x10FFFF in escape sequence"
    ],
    [
      e.OctalDeprecation,
      '"0"-prefixed octal literals and octal escape sequences are deprecated; for octal literals use the "0o" prefix instead'
    ],
    [e.EndOfString, "malformed escape sequence at end of string"]
  ]);
})(ie);
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.unraw = s.errorMessages = s.ErrorType = void 0;
  const e = ie;
  Object.defineProperty(s, "ErrorType", { enumerable: !0, get: function() {
    return e.ErrorType;
  } }), Object.defineProperty(s, "errorMessages", { enumerable: !0, get: function() {
    return e.errorMessages;
  } });
  function t(v) {
    return !v.match(/[^a-f0-9]/i) ? parseInt(v, 16) : NaN;
  }
  function n(v, x, _) {
    const E = t(v);
    if (Number.isNaN(E) || _ !== void 0 && _ !== v.length)
      throw new SyntaxError(e.errorMessages.get(x));
    return E;
  }
  function a(v) {
    const x = n(v, e.ErrorType.MalformedHexadecimal, 2);
    return String.fromCharCode(x);
  }
  function l(v, x) {
    const _ = n(v, e.ErrorType.MalformedUnicode, 4);
    if (x !== void 0) {
      const E = n(x, e.ErrorType.MalformedUnicode, 4);
      return String.fromCharCode(_, E);
    }
    return String.fromCharCode(_);
  }
  function o(v) {
    return v.charAt(0) === "{" && v.charAt(v.length - 1) === "}";
  }
  function g(v) {
    if (!o(v))
      throw new SyntaxError(e.errorMessages.get(e.ErrorType.MalformedUnicode));
    const x = v.slice(1, -1), _ = n(x, e.ErrorType.MalformedUnicode);
    try {
      return String.fromCodePoint(_);
    } catch (E) {
      throw E instanceof RangeError ? new SyntaxError(e.errorMessages.get(e.ErrorType.CodePointLimit)) : E;
    }
  }
  function m(v, x = !1) {
    if (x)
      throw new SyntaxError(e.errorMessages.get(e.ErrorType.OctalDeprecation));
    const _ = parseInt(v, 8);
    return String.fromCharCode(_);
  }
  const T = /* @__PURE__ */ new Map([
    ["b", "\b"],
    ["f", "\f"],
    ["n", `
`],
    ["r", "\r"],
    ["t", "	"],
    ["v", "\v"],
    ["0", "\0"]
  ]);
  function C(v) {
    return T.get(v) || v;
  }
  const M = /\\(?:(\\)|x([\s\S]{0,2})|u(\{[^}]*\}?)|u([\s\S]{4})\\u([^{][\s\S]{0,3})|u([\s\S]{0,4})|([0-3]?[0-7]{1,2})|([\s\S])|$)/g;
  function B(v, x = !1) {
    return v.replace(M, function(_, E, P, D, K, z, j, I, b) {
      if (E !== void 0)
        return "\\";
      if (P !== void 0)
        return a(P);
      if (D !== void 0)
        return g(D);
      if (K !== void 0)
        return l(K, z);
      if (j !== void 0)
        return l(j);
      if (I === "0")
        return "\0";
      if (I !== void 0)
        return m(I, !x);
      if (b !== void 0)
        return C(b);
      throw new SyntaxError(e.errorMessages.get(e.ErrorType.EndOfString));
    });
  }
  s.unraw = B, s.default = B;
})(ae);
var G = {}, oe = {}, le = { exports: {} };
(function(s) {
  (function(e, t) {
    s.exports ? s.exports = t() : e.moo = t();
  })(Z, function() {
    var e = Object.prototype.hasOwnProperty, t = Object.prototype.toString, n = typeof new RegExp().sticky == "boolean";
    function a(r) {
      return r && t.call(r) === "[object RegExp]";
    }
    function l(r) {
      return r && typeof r == "object" && !a(r) && !Array.isArray(r);
    }
    function o(r) {
      return r.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function g(r) {
      var i = new RegExp("|" + r);
      return i.exec("").length - 1;
    }
    function m(r) {
      return "(" + r + ")";
    }
    function T(r) {
      if (!r.length) return "(?!)";
      var i = r.map(function(u) {
        return "(?:" + u + ")";
      }).join("|");
      return "(?:" + i + ")";
    }
    function C(r) {
      if (typeof r == "string")
        return "(?:" + o(r) + ")";
      if (a(r)) {
        if (r.ignoreCase) throw new Error("RegExp /i flag not allowed");
        if (r.global) throw new Error("RegExp /g flag is implied");
        if (r.sticky) throw new Error("RegExp /y flag is implied");
        if (r.multiline) throw new Error("RegExp /m flag is implied");
        return r.source;
      } else
        throw new Error("Not a pattern: " + r);
    }
    function M(r, i) {
      return r.length > i ? r : Array(i - r.length + 1).join(" ") + r;
    }
    function B(r, i) {
      for (var u = r.length, c = 0; ; ) {
        var d = r.lastIndexOf(`
`, u - 1);
        if (d === -1 || (c++, u = d, c === i) || u === 0)
          break;
      }
      var f = c < i ? 0 : u + 1;
      return r.substring(f).split(`
`);
    }
    function v(r) {
      for (var i = Object.getOwnPropertyNames(r), u = [], c = 0; c < i.length; c++) {
        var d = i[c], f = r[d], p = [].concat(f);
        if (d === "include") {
          for (var w = 0; w < p.length; w++)
            u.push({ include: p[w] });
          continue;
        }
        var y = [];
        p.forEach(function(h) {
          l(h) ? (y.length && u.push(_(d, y)), u.push(_(d, h)), y = []) : y.push(h);
        }), y.length && u.push(_(d, y));
      }
      return u;
    }
    function x(r) {
      for (var i = [], u = 0; u < r.length; u++) {
        var c = r[u];
        if (c.include) {
          for (var d = [].concat(c.include), f = 0; f < d.length; f++)
            i.push({ include: d[f] });
          continue;
        }
        if (!c.type)
          throw new Error("Rule has no type: " + JSON.stringify(c));
        i.push(_(c.type, c));
      }
      return i;
    }
    function _(r, i) {
      if (l(i) || (i = { match: i }), i.include)
        throw new Error("Matching rules cannot also include states");
      var u = {
        defaultType: r,
        lineBreaks: !!i.error || !!i.fallback,
        pop: !1,
        next: null,
        push: null,
        error: !1,
        fallback: !1,
        value: null,
        type: null,
        shouldThrow: !1
      };
      for (var c in i)
        e.call(i, c) && (u[c] = i[c]);
      if (typeof u.type == "string" && r !== u.type)
        throw new Error("Type transform cannot be a string (type '" + u.type + "' for token '" + r + "')");
      var d = u.match;
      return u.match = Array.isArray(d) ? d : d ? [d] : [], u.match.sort(function(f, p) {
        return a(f) && a(p) ? 0 : a(p) ? -1 : a(f) ? 1 : p.length - f.length;
      }), u;
    }
    function E(r) {
      return Array.isArray(r) ? x(r) : v(r);
    }
    var P = _("error", { lineBreaks: !0, shouldThrow: !0 });
    function D(r, i) {
      for (var u = null, c = /* @__PURE__ */ Object.create(null), d = !0, f = null, p = [], w = [], y = 0; y < r.length; y++)
        r[y].fallback && (d = !1);
      for (var y = 0; y < r.length; y++) {
        var h = r[y];
        if (h.include)
          throw new Error("Inheritance is not allowed in stateless lexers");
        if (h.error || h.fallback) {
          if (u)
            throw !h.fallback == !u.fallback ? new Error("Multiple " + (h.fallback ? "fallback" : "error") + " rules not allowed (for token '" + h.defaultType + "')") : new Error("fallback and error are mutually exclusive (for token '" + h.defaultType + "')");
          u = h;
        }
        var S = h.match.slice();
        if (d)
          for (; S.length && typeof S[0] == "string" && S[0].length === 1; ) {
            var L = S.shift();
            c[L.charCodeAt(0)] = h;
          }
        if (h.pop || h.push || h.next) {
          if (!i)
            throw new Error("State-switching options are not allowed in stateless lexers (for token '" + h.defaultType + "')");
          if (h.fallback)
            throw new Error("State-switching options are not allowed on fallback tokens (for token '" + h.defaultType + "')");
        }
        if (S.length !== 0) {
          d = !1, p.push(h);
          for (var $ = 0; $ < S.length; $++) {
            var R = S[$];
            if (a(R)) {
              if (f === null)
                f = R.unicode;
              else if (f !== R.unicode && h.fallback === !1)
                throw new Error("If one rule is /u then all must be");
            }
          }
          var q = T(S.map(C)), k = new RegExp(q);
          if (k.test(""))
            throw new Error("RegExp matches empty string: " + k);
          var F = g(q);
          if (F > 0)
            throw new Error("RegExp has capture groups: " + k + `
Use (?: … ) instead`);
          if (!h.lineBreaks && k.test(`
`))
            throw new Error("Rule should declare lineBreaks: " + k);
          w.push(m(q));
        }
      }
      var N = u && u.fallback, H = n && !N ? "ym" : "gm", J = n || N ? "" : "|";
      f === !0 && (H += "u");
      var me = new RegExp(T(w) + J, H);
      return { regexp: me, groups: p, fast: c, error: u || P };
    }
    function K(r) {
      var i = D(E(r));
      return new b({ start: i }, "start");
    }
    function z(r, i, u) {
      var c = r && (r.push || r.next);
      if (c && !u[c])
        throw new Error("Missing state '" + c + "' (in token '" + r.defaultType + "' of state '" + i + "')");
      if (r && r.pop && +r.pop != 1)
        throw new Error("pop must be 1 (in token '" + r.defaultType + "' of state '" + i + "')");
    }
    function j(r, i) {
      var u = r.$all ? E(r.$all) : [];
      delete r.$all;
      var c = Object.getOwnPropertyNames(r);
      i || (i = c[0]);
      for (var d = /* @__PURE__ */ Object.create(null), f = 0; f < c.length; f++) {
        var p = c[f];
        d[p] = E(r[p]).concat(u);
      }
      for (var f = 0; f < c.length; f++)
        for (var p = c[f], w = d[p], y = /* @__PURE__ */ Object.create(null), h = 0; h < w.length; h++) {
          var S = w[h];
          if (S.include) {
            var L = [h, 1];
            if (S.include !== p && !y[S.include]) {
              y[S.include] = !0;
              var $ = d[S.include];
              if (!$)
                throw new Error("Cannot include nonexistent state '" + S.include + "' (in state '" + p + "')");
              for (var R = 0; R < $.length; R++) {
                var q = $[R];
                w.indexOf(q) === -1 && L.push(q);
              }
            }
            w.splice.apply(w, L), h--;
          }
        }
      for (var k = /* @__PURE__ */ Object.create(null), f = 0; f < c.length; f++) {
        var p = c[f];
        k[p] = D(d[p], !0);
      }
      for (var f = 0; f < c.length; f++) {
        for (var F = c[f], N = k[F], H = N.groups, h = 0; h < H.length; h++)
          z(H[h], F, k);
        for (var J = Object.getOwnPropertyNames(N.fast), h = 0; h < J.length; h++)
          z(N.fast[J[h]], F, k);
      }
      return new b(k, i);
    }
    function I(r) {
      for (var i = typeof Map < "u", u = i ? /* @__PURE__ */ new Map() : /* @__PURE__ */ Object.create(null), c = Object.getOwnPropertyNames(r), d = 0; d < c.length; d++) {
        var f = c[d], p = r[f], w = Array.isArray(p) ? p : [p];
        w.forEach(function(y) {
          if (typeof y != "string")
            throw new Error("keyword must be string (in keyword '" + f + "')");
          i ? u.set(y, f) : u[y] = f;
        });
      }
      return function(y) {
        return i ? u.get(y) : u[y];
      };
    }
    var b = function(r, i) {
      this.startState = i, this.states = r, this.buffer = "", this.stack = [], this.reset();
    };
    b.prototype.reset = function(r, i) {
      return this.buffer = r || "", this.index = 0, this.line = i ? i.line : 1, this.col = i ? i.col : 1, this.queuedToken = i ? i.queuedToken : null, this.queuedText = i ? i.queuedText : "", this.queuedThrow = i ? i.queuedThrow : null, this.setState(i ? i.state : this.startState), this.stack = i && i.stack ? i.stack.slice() : [], this;
    }, b.prototype.save = function() {
      return {
        line: this.line,
        col: this.col,
        state: this.state,
        stack: this.stack.slice(),
        queuedToken: this.queuedToken,
        queuedText: this.queuedText,
        queuedThrow: this.queuedThrow
      };
    }, b.prototype.setState = function(r) {
      if (!(!r || this.state === r)) {
        this.state = r;
        var i = this.states[r];
        this.groups = i.groups, this.error = i.error, this.re = i.regexp, this.fast = i.fast;
      }
    }, b.prototype.popState = function() {
      this.setState(this.stack.pop());
    }, b.prototype.pushState = function(r) {
      this.stack.push(this.state), this.setState(r);
    };
    var ge = n ? function(r, i) {
      return r.exec(i);
    } : function(r, i) {
      var u = r.exec(i);
      return u[0].length === 0 ? null : u;
    };
    b.prototype._getGroup = function(r) {
      for (var i = this.groups.length, u = 0; u < i; u++)
        if (r[u + 1] !== void 0)
          return this.groups[u];
      throw new Error("Cannot find token type for matched text");
    };
    function ye() {
      return this.value;
    }
    if (b.prototype.next = function() {
      var r = this.index;
      if (this.queuedGroup) {
        var i = this._token(this.queuedGroup, this.queuedText, r);
        return this.queuedGroup = null, this.queuedText = "", i;
      }
      var u = this.buffer;
      if (r !== u.length) {
        var p = this.fast[u.charCodeAt(r)];
        if (p)
          return this._token(p, u.charAt(r), r);
        var c = this.re;
        c.lastIndex = r;
        var d = ge(c, u), f = this.error;
        if (d == null)
          return this._token(f, u.slice(r, u.length), r);
        var p = this._getGroup(d), w = d[0];
        return f.fallback && d.index !== r ? (this.queuedGroup = p, this.queuedText = w, this._token(f, u.slice(r, d.index), r)) : this._token(p, w, r);
      }
    }, b.prototype._token = function(r, i, u) {
      var c = 0;
      if (r.lineBreaks) {
        var d = /\n/g, f = 1;
        if (i === `
`)
          c = 1;
        else
          for (; d.exec(i); )
            c++, f = d.lastIndex;
      }
      var p = {
        type: typeof r.type == "function" && r.type(i) || r.defaultType,
        value: typeof r.value == "function" ? r.value(i) : i,
        text: i,
        toString: ye,
        offset: u,
        lineBreaks: c,
        line: this.line,
        col: this.col
      }, w = i.length;
      if (this.index += w, this.line += c, c !== 0 ? this.col = w - f + 1 : this.col += w, r.shouldThrow) {
        var y = new Error(this.formatError(p, "invalid syntax"));
        throw y;
      }
      return r.pop ? this.popState() : r.push ? this.pushState(r.push) : r.next && this.setState(r.next), p;
    }, typeof Symbol < "u" && Symbol.iterator) {
      var Q = function(r) {
        this.lexer = r;
      };
      Q.prototype.next = function() {
        var r = this.lexer.next();
        return { value: r, done: !r };
      }, Q.prototype[Symbol.iterator] = function() {
        return this;
      }, b.prototype[Symbol.iterator] = function() {
        return new Q(this);
      };
    }
    return b.prototype.formatError = function(r, i) {
      if (r == null)
        var u = this.buffer.slice(this.index), r = {
          text: u,
          offset: this.index,
          lineBreaks: u.indexOf(`
`) === -1 ? 0 : 1,
          line: this.line,
          col: this.col
        };
      var c = 2, d = Math.max(r.line - c, 1), f = r.line + c, p = String(f).length, w = B(
        this.buffer,
        this.line - r.line + c + 1
      ).slice(0, 5), y = [];
      y.push(i + " at line " + r.line + " col " + r.col + ":"), y.push("");
      for (var h = 0; h < w.length; h++) {
        var S = w[h], L = d + h;
        y.push(M(String(L), p) + "  " + S), L === r.line && y.push(M("", p + r.col + 1) + "^");
      }
      return y.join(`
`);
    }, b.prototype.clone = function() {
      return new b(this.states, this.state);
    }, b.prototype.has = function(r) {
      return !0;
    }, {
      compile: K,
      states: j,
      error: Object.freeze({ error: !0 }),
      fallback: Object.freeze({ fallback: !0 }),
      keywords: I
    };
  });
})(le);
var we = le.exports;
(function(s) {
  var e = Z && Z.__importDefault || function(n) {
    return n && n.__esModule ? n : { default: n };
  };
  Object.defineProperty(s, "__esModule", { value: !0 }), s.lexer = s.states = void 0;
  const t = e(we);
  s.states = {
    body: {
      doubleapos: { match: "''", value: () => "'" },
      quoted: {
        lineBreaks: !0,
        match: /'[{}#](?:[^]*?[^'])?'(?!')/u,
        value: (n) => n.slice(1, -1).replace(/''/g, "'")
      },
      argument: {
        lineBreaks: !0,
        match: /\{\s*[^\p{Pat_Syn}\p{Pat_WS}]+\s*/u,
        push: "arg",
        value: (n) => n.substring(1).trim()
      },
      octothorpe: "#",
      end: { match: "}", pop: 1 },
      content: { lineBreaks: !0, match: /[^][^{}#']*/u }
    },
    arg: {
      select: {
        lineBreaks: !0,
        match: /,\s*(?:plural|select|selectordinal)\s*,\s*/u,
        next: "select",
        value: (n) => n.split(",")[1].trim()
      },
      "func-args": {
        lineBreaks: !0,
        match: /,\s*[^\p{Pat_Syn}\p{Pat_WS}]+\s*,/u,
        next: "body",
        value: (n) => n.split(",")[1].trim()
      },
      "func-simple": {
        lineBreaks: !0,
        match: /,\s*[^\p{Pat_Syn}\p{Pat_WS}]+\s*/u,
        value: (n) => n.substring(1).trim()
      },
      end: { match: "}", pop: 1 }
    },
    select: {
      offset: {
        lineBreaks: !0,
        match: /\s*offset\s*:\s*\d+\s*/u,
        value: (n) => n.split(":")[1].trim()
      },
      case: {
        lineBreaks: !0,
        match: /\s*(?:=\d+|[^\p{Pat_Syn}\p{Pat_WS}]+)\s*\{/u,
        push: "body",
        value: (n) => n.substring(0, n.indexOf("{")).trim()
      },
      end: { match: /\s*\}/u, pop: 1 }
    }
  }, s.lexer = t.default.states(s.states);
})(oe);
Object.defineProperty(G, "__esModule", { value: !0 });
var ue = G.parse = G.ParseError = void 0;
const ce = oe, W = (s) => ({
  offset: s.offset,
  line: s.line,
  col: s.col,
  text: s.text,
  lineBreaks: s.lineBreaks
}), Y = (s) => s === "plural" || s === "select" || s === "selectordinal";
function _e(s, e) {
  let t = "", n = "";
  for (const l of e) {
    const o = l.ctx.text;
    switch (n += o, l.type) {
      case "content":
        t += l.value;
        break;
      case "argument":
      case "function":
      case "octothorpe":
        t += o;
        break;
      default:
        throw new O(s, `Unsupported part in strict mode function arg style: ${o}`);
    }
  }
  return [{
    type: "content",
    value: t.trim(),
    ctx: Object.assign({}, e[0].ctx, { text: n })
  }];
}
const xe = [
  "number",
  "date",
  "time",
  "spellout",
  "ordinal",
  "duration"
], re = ["zero", "one", "two", "few", "many", "other"];
class O extends Error {
  /** @internal */
  constructor(e, t) {
    super(ce.lexer.formatError(e, t));
  }
}
G.ParseError = O;
class Ee {
  constructor(e, t) {
    var n, a, l, o;
    this.lexer = ce.lexer.reset(e), this.cardinalKeys = (n = t == null ? void 0 : t.cardinal) !== null && n !== void 0 ? n : re, this.ordinalKeys = (a = t == null ? void 0 : t.ordinal) !== null && a !== void 0 ? a : re, this.strict = (l = t == null ? void 0 : t.strict) !== null && l !== void 0 ? l : !1, this.strictPluralKeys = (o = t == null ? void 0 : t.strictPluralKeys) !== null && o !== void 0 ? o : !0;
  }
  parse() {
    return this.parseBody(!1, !0);
  }
  checkSelectKey(e, t, n) {
    if (n[0] === "=") {
      if (t === "select")
        throw new O(e, `The case ${n} is not valid with select`);
    } else if (t !== "select") {
      const a = t === "plural" ? this.cardinalKeys : this.ordinalKeys;
      if (this.strictPluralKeys && a.length > 0 && !a.includes(n)) {
        const l = `The ${t} case ${n} is not valid in this locale`;
        throw new O(e, l);
      }
    }
  }
  parseSelect({ value: e }, t, n, a) {
    const l = { type: a, arg: e, cases: [], ctx: n };
    a === "plural" || a === "selectordinal" ? t = !0 : this.strict && (t = !1);
    for (const o of this.lexer)
      switch (o.type) {
        case "offset":
          if (a === "select")
            throw new O(o, "Unexpected plural offset for select");
          if (l.cases.length > 0)
            throw new O(o, "Plural offset must be set before cases");
          l.pluralOffset = Number(o.value), n.text += o.text, n.lineBreaks += o.lineBreaks;
          break;
        case "case": {
          this.checkSelectKey(o, a, o.value), l.cases.push({
            key: o.value,
            tokens: this.parseBody(t),
            ctx: W(o)
          });
          break;
        }
        case "end":
          return l;
        default:
          throw new O(o, `Unexpected lexer token: ${o.type}`);
      }
    throw new O(null, "Unexpected message end");
  }
  parseArgToken(e, t) {
    const n = W(e), a = this.lexer.next();
    if (!a)
      throw new O(null, "Unexpected message end");
    if (n.text += a.text, n.lineBreaks += a.lineBreaks, this.strict && (a.type === "func-simple" || a.type === "func-args") && !xe.includes(a.value)) {
      const l = `Invalid strict mode function arg type: ${a.value}`;
      throw new O(e, l);
    }
    switch (a.type) {
      case "end":
        return { type: "argument", arg: e.value, ctx: n };
      case "func-simple": {
        const l = this.lexer.next();
        if (!l)
          throw new O(null, "Unexpected message end");
        if (l.type !== "end")
          throw new O(l, `Unexpected lexer token: ${l.type}`);
        if (n.text += l.text, Y(a.value.toLowerCase()))
          throw new O(a, `Invalid type identifier: ${a.value}`);
        return {
          type: "function",
          arg: e.value,
          key: a.value,
          ctx: n
        };
      }
      case "func-args": {
        if (Y(a.value.toLowerCase())) {
          const o = `Invalid type identifier: ${a.value}`;
          throw new O(a, o);
        }
        let l = this.parseBody(this.strict ? !1 : t);
        return this.strict && l.length > 0 && (l = _e(e, l)), {
          type: "function",
          arg: e.value,
          key: a.value,
          param: l,
          ctx: n
        };
      }
      case "select":
        if (Y(a.value))
          return this.parseSelect(e, t, n, a.value);
        throw new O(a, `Unexpected select type ${a.value}`);
      default:
        throw new O(a, `Unexpected lexer token: ${a.type}`);
    }
  }
  parseBody(e, t) {
    const n = [];
    let a = null;
    for (const l of this.lexer)
      if (l.type === "argument")
        a && (a = null), n.push(this.parseArgToken(l, e));
      else if (l.type === "octothorpe" && e)
        a && (a = null), n.push({ type: "octothorpe", ctx: W(l) });
      else {
        if (l.type === "end" && !t)
          return n;
        {
          let o = l.value;
          if (!e && l.type === "quoted" && o[0] === "#") {
            if (o.includes("{")) {
              const g = `Unsupported escape pattern: ${o}`;
              throw new O(l, g);
            }
            o = l.text;
          }
          a ? (a.value += o, a.ctx.text += l.text, a.ctx.lineBreaks += l.lineBreaks) : (a = { type: "content", value: o, ctx: W(l) }, n.push(a));
        }
      }
    if (t)
      return n;
    throw new O(null, "Unexpected message end");
  }
}
function be(s, e = {}) {
  return new Ee(s, e).parse();
}
ue = G.parse = be;
function fe(s, e) {
  return s.filter((t) => t.type !== "content").length ? s.map((t) => {
    var l;
    if (t.type === "content")
      return e(t.value);
    if (t.type === "octothorpe")
      return "#";
    if (t.type === "argument")
      return [t.arg];
    if (t.type === "function") {
      const o = (l = t == null ? void 0 : t.param) == null ? void 0 : l[0];
      return o ? [t.arg, t.key, o.value.trim()] : [t.arg, t.key];
    }
    const n = t.pluralOffset, a = {};
    return t.cases.forEach(({ key: o, tokens: g }) => {
      const m = o[0] === "=" ? o.slice(1) : o;
      a[m] = fe(g, e);
    }), [
      t.arg,
      t.type,
      {
        offset: n,
        ...a
      }
    ];
  }) : s.map((t) => e(t.value)).join("");
}
function Oe(s, e = (t) => t) {
  try {
    return fe(ue(s), e);
  } catch (t) {
    return console.error(`${t.message} 

Message: ${s}`), s;
  }
}
const A = (s) => typeof s == "string", Se = (s) => typeof s == "function", ne = /* @__PURE__ */ new Map(), he = "en";
function te(s) {
  return [...Array.isArray(s) ? s : [s], he];
}
function de(s, e, t) {
  const n = te(s);
  return V(
    () => X("date", n, t),
    () => new Intl.DateTimeFormat(n, t)
  ).format(A(e) ? new Date(e) : e);
}
function ee(s, e, t) {
  const n = te(s);
  return V(
    () => X("number", n, t),
    () => new Intl.NumberFormat(n, t)
  ).format(e);
}
function se(s, e, t, { offset: n = 0, ...a }) {
  const l = te(s), o = e ? V(
    () => X("plural-ordinal", l),
    () => new Intl.PluralRules(l, { type: "ordinal" })
  ) : V(
    () => X("plural-cardinal", l),
    () => new Intl.PluralRules(l, { type: "cardinal" })
  );
  return a[t] ?? a[o.select(t - n)] ?? a.other;
}
function V(s, e) {
  const t = s();
  let n = ne.get(t);
  return n || (n = e(), ne.set(t, n)), n;
}
function X(s, e, t) {
  const n = e.join("-");
  return `${s}-${n}-${JSON.stringify(t)}`;
}
const pe = /\\u[a-fA-F0-9]{4}|\\x[a-fA-F0-9]{2}/g, ve = "%__lingui_octothorpe__%", Te = (s, e, t = {}) => {
  const n = e || s, a = (o) => typeof o == "object" ? o : t[o] || { style: o }, l = (o, g) => {
    const m = Object.keys(t).length ? a("number") : void 0, T = ee(n, o, m);
    return g.replace(new RegExp(ve, "g"), T);
  };
  return {
    plural: (o, g) => {
      const { offset: m = 0 } = g, T = se(n, !1, o, g);
      return l(o - m, T);
    },
    selectordinal: (o, g) => {
      const { offset: m = 0 } = g, T = se(n, !0, o, g);
      return l(o - m, T);
    },
    select: ke,
    number: (o, g) => ee(n, o, a(g)),
    date: (o, g) => de(n, o, a(g))
  };
}, ke = (s, e) => e[s] ?? e.other;
function Me(s, e, t) {
  return (n = {}, a) => {
    const l = Te(e, t, a), o = (m, T = !1) => Array.isArray(m) ? m.reduce((C, M) => {
      if (M === "#" && T)
        return C + ve;
      if (A(M))
        return C + M;
      const [B, v, x] = M;
      let _ = {};
      v === "plural" || v === "selectordinal" || v === "select" ? Object.entries(x).forEach(
        ([P, D]) => {
          _[P] = o(
            D,
            v === "plural" || v === "selectordinal"
          );
        }
      ) : _ = x;
      let E;
      if (v) {
        const P = l[v];
        E = P(n[B], _);
      } else
        E = n[B];
      return E == null ? C : C + E;
    }, "") : m, g = o(s);
    return A(g) && pe.test(g) ? ae.unraw(g.trim()) : A(g) ? g.trim() : g ? String(g) : "";
  };
}
var Ce = Object.defineProperty, Pe = (s, e, t) => e in s ? Ce(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t, Ae = (s, e, t) => (Pe(s, e + "", t), t);
class Be {
  constructor() {
    Ae(this, "_events", {});
  }
  on(e, t) {
    var n;
    return (n = this._events)[e] ?? (n[e] = []), this._events[e].push(t), () => this.removeListener(e, t);
  }
  removeListener(e, t) {
    const n = this._getListeners(e);
    if (!n)
      return;
    const a = n.indexOf(t);
    ~a && n.splice(a, 1);
  }
  emit(e, ...t) {
    const n = this._getListeners(e);
    n && n.map((a) => a.apply(this, t));
  }
  _getListeners(e) {
    const t = this._events[e];
    return Array.isArray(t) ? t : !1;
  }
}
var De = Object.defineProperty, Le = (s, e, t) => e in s ? De(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t, U = (s, e, t) => (Le(s, typeof e != "symbol" ? e + "" : e, t), t);
class $e extends Be {
  constructor(e) {
    super(), U(this, "_locale", ""), U(this, "_locales"), U(this, "_localeData", {}), U(this, "_messages", {}), U(this, "_missing"), U(this, "t", this._.bind(this)), e.missing != null && (this._missing = e.missing), e.messages != null && this.load(e.messages), e.localeData != null && this.loadLocaleData(e.localeData), (typeof e.locale == "string" || e.locales) && this.activate(e.locale ?? he, e.locales);
  }
  get locale() {
    return this._locale;
  }
  get locales() {
    return this._locales;
  }
  get messages() {
    return this._messages[this._locale] ?? {};
  }
  /**
   * @deprecated this has no effect. Please remove this from the code. Deprecated in v4
   */
  get localeData() {
    return this._localeData[this._locale] ?? {};
  }
  _loadLocaleData(e, t) {
    const n = this._localeData[e];
    n ? Object.assign(n, t) : this._localeData[e] = t;
  }
  /**
   * @deprecated Plurals automatically used from Intl.PluralRules you can safely remove this call. Deprecated in v4
   */
  // @ts-ignore deprecated, so ignore the reported error
  loadLocaleData(e, t) {
    t != null ? this._loadLocaleData(e, t) : Object.keys(e).forEach(
      (n) => this._loadLocaleData(n, e[n])
    ), this.emit("change");
  }
  _load(e, t) {
    const n = this._messages[e];
    n ? Object.assign(n, t) : this._messages[e] = t;
  }
  load(e, t) {
    typeof e == "string" && typeof t == "object" ? this._load(e, t) : Object.entries(e).forEach(
      ([n, a]) => this._load(n, a)
    ), this.emit("change");
  }
  /**
   * @param options {@link LoadAndActivateOptions}
   */
  loadAndActivate({ locale: e, locales: t, messages: n }) {
    this._locale = e, this._locales = t || void 0, this._messages[this._locale] = n, this.emit("change");
  }
  activate(e, t) {
    process.env.NODE_ENV !== "production" && (this._messages[e] || console.warn(`Messages for locale "${e}" not loaded.`)), this._locale = e, this._locales = t, this.emit("change");
  }
  _(e, t, n) {
    let a = n == null ? void 0 : n.message;
    e || (e = ""), A(e) || (t = e.values || t, a = e.message, e = e.id);
    const l = this.messages[e], o = l === void 0, g = this._missing;
    if (g && o)
      return Se(g) ? g(this._locale, e) : g;
    o && this.emit("missing", { id: e, locale: this._locale });
    let m = l || a || e;
    return process.env.NODE_ENV !== "production" && (m = A(m) ? Oe(m) : m), A(m) && pe.test(m) ? JSON.parse(`"${m}"`) : A(m) ? m : Me(
      m,
      this._locale,
      this._locales
    )(t, n == null ? void 0 : n.formats);
  }
  date(e, t) {
    return de(this._locales || this._locale, e, t);
  }
  number(e, t) {
    return ee(this._locales || this._locale, e, t);
  }
}
function Re(s = {}) {
  return new $e(s);
}
const Ne = Re();
export {
  Ne as i
};
